var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customize-message-step-container" },
    [
      _c("div", { staticClass: "row mb-3 align-items-center" }, [
        _c("div", { staticClass: "col" }, [
          _c("p", { staticClass: "mb-2" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("request-package.customizeMessage.subtitle")) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-5" }, [
          _c("div", { staticClass: "form-container form-group-material" }, [
            _c(
              "select",
              {
                staticClass:
                  "form-control form-control-filled material-input-static-label material-input py-0 form my-1 select-field",
                domProps: { value: _vm.selectedEmailTemplate },
                on: { change: _vm.handleTemplateSelected },
              },
              [
                _c(
                  "option",
                  {
                    staticClass: "text-grey",
                    attrs: { selected: "", value: "" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("templates.messages.noTemplateSelected")
                        ) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.emptyDocumentRequestTemplates
                  ? _c(
                      "option",
                      {
                        staticClass: "text-grey",
                        attrs: { disabled: "", selected: "" },
                        domProps: { value: null },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("templates.messages.noTemplatesFound")
                            ) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.documentRequestTemplates.byId, function (template) {
                  return _c(
                    "option",
                    { key: template.id, domProps: { value: template.id } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(template.name) +
                          "\n          "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("span", { staticClass: "bar" }),
            _vm._v(" "),
            _c("label", { staticClass: "title text-light-gray mb-2 mb-lg-0" }, [
              _vm._v(_vm._s(_vm.$t("templates.messages.orSelectATemplate"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "col-auto d-flex flex-row justify-content-center pl-0",
          },
          [
            _c("i", {
              staticClass: "clickable fa fa-gear mb-2",
              on: {
                click: function ($event) {
                  _vm.showSettings = !_vm.showSettings
                },
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c("bulk-request-modal-loader", {
            staticStyle: { width: "100%", height: "200px" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("email-editor", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading,
            expression: "!loading",
          },
        ],
        ref: "emailEditor",
        attrs: {
          "substitution-hints": true,
          "show-merge-tags": true,
          "show-application-merge-tags": false,
          "air-mode": "",
          "email-body": _vm.userMessage,
          attachments: false,
          "dialogs-in-body": true,
        },
        on: { change: _vm.updateUserMessage },
      }),
      _vm._v(" "),
      _vm.showSettings
        ? _c("div", { staticClass: "row mt-3 align-items-center" }, [
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c("div", { staticClass: "form-group-material" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newTemplateName,
                      expression: "newTemplateName",
                    },
                  ],
                  staticClass:
                    "form-control form-control-sm material-input-static-label form-control-filled",
                  attrs: { type: "text", name: "newTemplateName" },
                  domProps: { value: _vm.newTemplateName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newTemplateName = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "bar" }),
                _vm._v(" "),
                _c("label", [_vm._v(_vm._s(_vm.$t("templates.templateName")))]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-3 d-flex flex-row align-items-center",
              },
              [
                _c("div", { staticClass: "dropup" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-primary clickable btn-sm dropdown-toggle",
                      attrs: {
                        "data-toggle": "dropdown",
                        role: "button",
                        "aria-haspopup": "true",
                        "aria-expanded": "false",
                        disabled: !_vm.allowSaveNew,
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("global.words.save")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu dropdown-menu-right py-1",
                      staticStyle: { "min-width": "auto" },
                      attrs: { "aria-labelledby": "dropdownMenuLink" },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item clickable py-1 px-3",
                          on: { click: _vm.handleSaveNewTemplate },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("global.actions.saveAsNew")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.selectedEmailTemplate
                        ? [
                            _c("div", { staticClass: "dropdown-divider my-1" }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "dropdown-item clickable py-1 px-3",
                                on: { click: _vm.handleUpdateTemplate },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "request-package.customizeMessage.updateCurrent"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _vm.selectedEmailTemplate
                  ? _c(
                      "div",
                      { staticClass: "request-trash ml-2" },
                      [
                        _c(
                          "inline-prompt",
                          {
                            staticClass: "d-inline-block",
                            on: { accept: _vm.handleDeleteTemplate },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-danger btn-sm text-white",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("global.words.delete")) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }